import Swiper from "swiper";
import { A11y, Autoplay, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";
import "./courts.css";

document.querySelectorAll(".element-courts.as-slider").forEach((el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, Navigation],
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1.5,
    spaceBetween: 24,
    speed: 700,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3.2,
        slidesPerGroup: 3,
        spaceBetween: 48,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
